module.exports = __webpack_public_path__ + "img/11_94.da15b92d.png";